import { Col, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { ISecondLastNameField } from "./ISecondLastNameField";
import { sizes } from "../../../Assets/Enums";

const SecondLastNameField = ({
	lastName,
	translations,
	errors,
	index = 0,
	handleChangeData,
	size = "m",
	disabled = false,
	required = false
}: ISecondLastNameField) => (
	<Col xs={24} md={sizes[size]} lg={sizes[size]} >
		<label className={required ? "required" : ""}>
			{translations.secondLastnameSignatory}
			<Tooltip placement="top" title={<span>{translations.signerNameTooltip}</span>}>
				{" "} <InfoCircleOutlined />
			</Tooltip>
		</label>
		<Input
			className="input-field"
			name="secondLastName"
			value={lastName}
			onChange={handleChangeData(index)}
			placeholder={translations.secondLastnameSignatory}
			disabled={disabled}
			status={
				Array.isArray(errors)
					? (errors[index]?.secondLastName || errors[index]?.invalidSecondLastNameFormat ? "error" : "")
					: (errors.secondLastName || errors.invalidSecondLastNameFormat ? "error" : "")
			}
		/>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.secondLastName ? 'show' : null
				: errors.secondLastName ? 'show' : null
		}`}>
			{translations.completeCampo}
		</span>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.invalidSecondLastNameFormat ? 'show' : null
				: errors.invalidSecondLastNameFormat ? 'show' : null
		}`}>
			{translations.invalidFormat}
		</span>
	</Col>
);

export default SecondLastNameField;